import { stumble } from '../stumble/stumble';

/**
 * Transform React warnings (bad element nesting, missing key etc.) into stumble()
 */
export const escalateReactWarnings = () => {
  // wouldn't work in React production build anyway, so rather avoid false-positives
  // e.g. from browser plugins using similar warning messages in production.
  if (process.env.NODE_ENV === 'development') {
    const oldConsoleError = console.error;
    console.error = (...args: unknown[]) => {
      oldConsoleError.apply(console, args);
      // Seems that this is the best way to recognize React warnings.
      // Occasional false positives (other error source) are acceptable in development.
      if (typeof args[0] === 'string' && args[0].startsWith('Warning: ')) {
        stumble('React warning encountered. See console for details.');
      }
    };
  }
};
